<template>
  <Fragment>
    <Switcher
      name="interval"
      v-model="selectedInterval"
      leftValue="month"
      leftText="Monthly"
      rightValue="year"
      rightText="Yearly"
      save-text="Save 16%"
      style="margin-bottom: 1.5rem"
    />

    <div class="plan-sliders">
      <Slider
        v-model="profiles"
        :step="1"
        :min="1"
        :max="40"
        thumb-label="always"
        style="margin-bottom: 1rem; margin-top: 3.25rem"
      >
        <template #thumb-label="{ value }">
          {{ value }} profile{{ value === 1 ? '' : 's' }}
        </template>
      </Slider>
    </div>

    <div class="plans">
      <ProPlusPlan
        :interval="selectedInterval"
        :profiles="profiles"
        :blocks="planBlocks"
      >
        <template slot="actions">
          <Button
            href="https://app.campsite.bio/create-account?pro_plus=1"
            size="large"
            >Start Your Free Trial</Button
          >
        </template>
        <template slot="below-actions">
          10-day trial included •
          <InlineLink to="/demo">Request a demo</InlineLink>
        </template>
      </ProPlusPlan>
      <ProPlan
        :interval="selectedInterval"
        :profiles="profiles"
        :blocks="planBlocks"
      >
        <template slot="actions">
          <Button
            href="https://app.campsite.bio/create-account?pro=1"
            size="large"
            >Start Your Free Trial</Button
          >
        </template>
        <template slot="below-actions"> 10-day trial included </template>
      </ProPlan>
      <FreePlan :disabled="profiles > 1">
        <template slot="actions">
          <Button
            href="https://app.campsite.bio/create-account"
            variant="outline"
            size="large"
            >Get Started Free</Button
          >
        </template>
      </FreePlan>
    </div>
  </Fragment>
</template>

<script>
import {
  Button,
  InlineLink,
  Slider,
  LinkIcon,
  PersonIcon,
} from '@campsite-bio/component-lib';
import { computed, ref } from '@nuxtjs/composition-api';

import Switcher from '@/components/switcher';
import FreePlan from './free-plan';
import ProPlan from './pro-plan';
import ProPlusPlan from './pro-plus-plan';
import { COLLABORATOR_PRICES, PROFILE_PRICES } from './plans';

export default {
  setup() {
    const selectedInterval = ref('month');
    const profiles = ref(1);

    const planBlocks = computed(() => {
      const profilePrice = Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      }).format(PROFILE_PRICES[selectedInterval.value]);
      const collaboratorPrice = Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      }).format(COLLABORATOR_PRICES[selectedInterval.value]);

      return [
        {
          icon: LinkIcon,
          title: `${profilePrice} per additional profile / ${selectedInterval.value}`,
        },
        {
          icon: PersonIcon,
          title: `${collaboratorPrice} per additional collaborator / ${selectedInterval.value}`,
        },
      ];
    });

    return {
      selectedInterval,
      profiles,
      planBlocks,
    };
  },

  components: {
    Switcher,
    Button,
    FreePlan,
    ProPlan,
    ProPlusPlan,
    InlineLink,
    Slider,
  },
};
</script>

<style lang="scss" scoped>
.plans {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  margin: 1.5rem 0;
  text-align: left;
}
</style>
